<template>
    <div class="table-checkout text-left">
        <!-- MOBILE VERSION - PART1 --------------------->
        <div class="table-novi table-custom-responsive mobile-component">
            <table class="table-custom table-custom-bordered">
                <thead>
                    <tr>
                        <th class="th-header"><span class="row-text detail-title">サービス情報詳細</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="content-row">
                        <td>
                            <div class="mobile-div-text"><span class="row-text">ご注文番号：{{eowp.subscription.csOrderNo}}</span></div>
                            <br />
                            <div class="mobile-div-text"><span class="row-text">ご注文日：{{eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.orderDate : eowp.subscription.orderDate}}</span></div>
                        </td>
                    </tr>
                    <tr class="content-row" v-if="eowp.subscription.oldSubscription">
                        <td>
                            <div class="mobile-div-text"><span class="row-text">※ご注文 (番号: {{eowp.subscription.oldSubscription.csOrderNo}}) から変更がありました。情報は引き継がれておりますのでご安心ください。</span></div>
                        </td>
                    </tr>
                    <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                        <td>
                            <div class="mobile-div-text"><span class="row-text">{{eowp.subscription.productName}}</span></div>
                        </td>
                    </tr>
                    <tr class="content-row" v-show="eowp.showDetail">
                        <td>
                            <div class="mobile-div-text"><span class="row-text">◆ご利用状況</span></div>
                        </td>
                    </tr>
                    <tr class="content-row" v-show="eowp.showDetail">
                        <td>
                            <div class="mobile-div-text">
                                <span class="row-text text-justify">{{eowp.useStatus[eowp.subscription.useStatus]}}</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="content-row" v-if="!eowp.externalSubscription" v-show="eowp.showDetail">
                        <td>
                            <div class="mobile-div-text">
                                <span class="row-text">利用開始日 : {{eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.validFrom : eowp.subscription.validFrom}}</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="content-row" v-if="!eowp.externalSubscription" v-show="eowp.showDetail">
                        <td>
                            <div class="mobile-div-text" v-if="eowp.subscription.useStatus != '0'">
                                <span class="row-text">利用停止日 : {{eowp.subscriptionCycle[eowp.subscription.useStatus]}}</span>
                            </div>
                            <div class="mobile-div-text" v-if="eowp.subscription.useStatus == '0'">
                                <span class="row-text">
                                    利用停止日 : {{transformUseDescription(eowp.textReference[2], eowp.subscription.validTo)}}
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-show="!eowp.showDetail">
                    <tr class="content-row">
                        <td>
                            <div class="click-to-load mobile-div-text-center">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-down"></span>
                                <a class="link" href="#!" @click="showDetail(true)">この注文の詳細を見る</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- END MOBILE VERSION - PART1 --------------------->

        <!-- DESKTOP VERSION - PART1 ------------------------>
        <div class="table-novi table-custom-responsive desktop-component">
            <table class="table-custom table-custom-bordered">
                <thead>
                    <tr>
                        <th class="th-header"><span class="row-text detail-title">サービス情報詳細</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="content-row">
                        <td><span class="row-text">ご注文番号：{{eowp.subscription.csOrderNo}}&#12288;ご注文日：{{!eowp.externalSubscription ? (eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.orderDate : eowp.subscription.orderDate) : ''}}</span></td>
                    </tr>
                    <tr class="content-row" v-if="eowp.subscription.oldSubscription">
                        <td><span class="row-text">※ご注文 (番号: {{eowp.subscription.oldSubscription.csOrderNo}}) から変更がありました。情報は引き継がれておりますのでご安心ください。</span></td>
                    </tr>
                    <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                        <td>
                            <span class="row-text">{{eowp.subscription.productName}}</span>
                        </td>
                    </tr>
                    <tr class="content-row" v-show="eowp.showDetail">
                        <td><span class="row-text">◆ご利用状況</span></td>
                    </tr>
                    <tr class="content-row" v-show="eowp.showDetail">
                        <td>
                            <span class="row-text text-justify">{{eowp.useStatus[eowp.subscription.useStatus]}}</span>
                        </td>
                    </tr>
                    <tr class="content-row" v-if="!eowp.externalSubscription" v-show="eowp.showDetail">
                        <td>
                            <span class="row-text">利用開始日 : {{eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.validFrom : eowp.subscription.validFrom}}</span>
                        </td>
                    </tr>
                    <tr class="content-row" v-if="!eowp.externalSubscription" v-show="eowp.showDetail">
                        <td>
                            <span v-if="eowp.subscription.useStatus != '0'" class="row-text">利用停止日 : {{eowp.subscriptionCycle[eowp.subscription.useStatus]}}</span>
                            <span v-if="eowp.subscription.useStatus == '0'" class="row-text">
                                利用停止日 : {{transformUseDescription(eowp.textReference[2], eowp.subscription.validTo)}}</span>
                        </td>
                    </tr>
                </tbody>
                <tbody v-show="!eowp.showDetail">
                    <tr class="content-row">
                        <td>
                            <div class="click-to-load">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-down"></span>
                                <a class="link" href="#!" @click="showDetail(true)">この注文の詳細を見る</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- END DESKTOP VERSION - PART1 -------------------->


        <!-- MOBILE VERSION - PART2 ------------------------->
        <div class="table-novi table-custom-responsive no-top-div force-hide account-table" :class="eowp.showDetail ? 'mobile-component' : ''" v-show="eowp.showDetail">
            <table class="table-custom table-custom-bordered">
                <thead>
                    <tr>
                        <th class="th-header"><span class="row-text detail-title">お支払い履歴・明細</span></th>
                    </tr>
                </thead>
                <tbody v-if="eowp.transactionHistory.length">
                    <tr v-for="(obj, index) in eowp.transactionHistory" class="content-row" v-bind:key="'mobile-'+index" v-show="showTransaction(index)">
                        <td>
                            <div class="mobile-div-text">
                                <span class="row-text">{{obj.paymentDate}}&nbsp;&nbsp;</span>
                                <span class="row-text">{{eowp.paymentStatus[obj.paymentStatus]}}</span>
                                <span v-if="obj.firstMonthFree == '1'" class="row-text">{{purchasedTrialIndicator(obj)}}</span>
                            </div>
                            <br />
                            <div class="mobile-div-text">
                                <span class="row-text">{{eowp.paymentFrequencyDescription[eowp.subscriptionType]}}</span>
                                <span class="row-text">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                <span class="row-text">{{formatPrice(obj.paymentPrice)}}円</span>
                            </div>
                            <br />
                            <div class="mobile-div-text-right" v-if="obj.receiptIssuedStatus == '1'">
                                <span v-if="obj.firstMonthFree != '1'" class="receipt-issued-mobile">領収書発行済み</span>
                            </div>
                            <div class="mobile-div-text" v-if="obj.receiptIssuedStatus == '0'">
                                <div 
                                    @click="receipt(obj.csOrderNo, obj.paymentLogSeq, index)" 
                                    v-if="obj.firstMonthFree != '1' && obj.paymentStatus != eowp.paymentStatusFlag.FAILED" 
                                    class="button buttons button-xs button-default-outline mobile-button-transaction tooltip-grey-instant-title">
                                    領収書を発行
                                    <img class="loading-receipt-btn" v-if="eowp.nthReceiptButtonClicked == index" src="/images/eowp/animation/loading-spinner.jpg" />
                                    <span class="tooltip-grey-instant-text" v-html="eowp.receiptPrintTooltip"></span>
                                </div>
                            </div>
                        </td>
                    </tr>    
                </tbody>

                <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.defaultItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                    <tr class="content-row">
                        <td>
                            <div class="mobile-div-text-center">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-down"></span>
                                <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.maxItems, 'expand_prevtable_transaction_list')">もっと見る</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.maxItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                    <tr class="content-row">
                        <td>
                            <div class="mobile-div-text-center">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-up"></span>
                                <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.defaultItems, 'collapse_prevtable_transaction_list')">お支払い履歴を閉じる</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="!eowp.transactionHistory.length">
                    <tr>
                        <td class="content-row">
                            <div class="mobile-div-text">
                                <span v-if="!eowp.externalSubscription" class="row-text">お支払い履歴はありません。</span>
                                <span v-if="eowp.externalSubscription" class="row-text">{{eowp.textReference[3]}}</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-show="eowp.transactionHistory.length <= 3 && eowp.showDetail">
                    <tr class="content-row">
                        <td>
                            <div class="click-to-load mobile-div-text-center">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-up"></span>
                                <a class="link" href="#!" @click="showDetail(false)">この注文の詳細を閉じる</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- END MOBILE VERSION - PART2 --------------------->

        <!-- DESKTOP VERSION - PART2 ------------------------>
        <div class="table-novi table-custom-responsive no-top-div force-hide account-table" :class="eowp.showDetail ? 'desktop-component' : ''" v-show="eowp.showDetail">
            <table class="table-custom table-hover transaction-history-table">
                <thead>
                    <tr>
                        <th class="th-header" colspan="5"><span class="row-text detail-title">お支払い履歴・明細</span></th>
                    </tr>
                    <tr v-if="eowp.transactionHistory.length">
                        <th><span class="row-text detail-title">請求日</span></th>
                        <th><span class="row-text detail-title">お支払い状況</span></th>
                        <th><span class="row-text detail-title">コース</span></th>
                        <th><span class="row-text detail-title">料金（税込）</span></th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody v-if="eowp.transactionHistory.length">
                    <tr v-for="(obj, index) in eowp.transactionHistory" class="content-row" v-bind:key="index" v-show="showTransaction(index)">
                        <td><span class="row-text">{{obj.paymentDate}}</span></td>
                        <td>
                            <span class="row-text">{{eowp.paymentStatus[obj.paymentStatus]}}</span>
                            <span v-if="obj.firstMonthFree == '1'" class="row-text">{{purchasedTrialIndicator(obj)}}</span>
                        </td>
                        <td><span class="row-text">{{eowp.paymentFrequencyDescription[eowp.subscriptionType]}}</span></td>
                        <td><span class="row-text">{{formatPrice(obj.paymentPrice)}}円</span></td>
                        <td v-if="obj.receiptIssuedStatus == '1'">
                            <span v-if="obj.firstMonthFree != '1'" class="receipt-issued">領収書発行済み</span>
                        </td>
                        <td v-if="obj.receiptIssuedStatus == '0'">
                            <div 
                                @click="receipt(obj.csOrderNo, obj.paymentLogSeq, index)"
                                v-if="obj.firstMonthFree != '1' && obj.paymentStatus != eowp.paymentStatusFlag.FAILED" 
                                class="button buttons button-xs button-default-outline tooltip-grey-instant-title">
                                領収書を発行
                                <img class="loading-receipt-btn" v-if="eowp.nthReceiptButtonClicked == index" src="/images/eowp/animation/loading-spinner.jpg" />
                                <span class="tooltip-grey-instant-text" v-html="eowp.receiptPrintTooltip"></span>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.defaultItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                    <tr class="content-row">
                        <td colspan="5">
                            <div class="click-to-load">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-down"></span>
                                <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.maxItems,'expand_prevtable_transaction_list')">もっと見る</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.maxItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                    <tr class="content-row">
                        <td colspan="5">
                            <div class="click-to-load">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-up"></span>
                                <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.defaultItems, 'collapse_prevtable_transaction_list')">お支払い履歴を閉じる</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="!eowp.transactionHistory.length">
                    <tr>
                        <td class="content-row text-left" colspan="5">
                            <span v-if="!eowp.externalSubscription" class="row-text">お支払い履歴はありません。</span>
                            <span v-if="eowp.externalSubscription" class="row-text">{{ eowp.textReference[3] }}</span>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="!eowp.externalOnly" v-show="eowp.transactionHistory.length <= 3 && eowp.showDetail">
                    <tr>
                        <td class="content-row" colspan="5">
                            <div class="click-to-load">
                                <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-up"></span>
                                <a class="link" href="#!" @click="showDetail(false)">この注文の詳細を閉じる</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- END DESKTOP VERSION - PART2 -------------------->
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 360px){
    table td .mobile-button3{
        margin-left: 50%!important;
        left: -55px!important;
        float: left!important;
        margin-top: 10px!important;
    }
}
@media screen and (max-width: 420px){
    table td .mobile-button2{
        margin-left: 50%!important;
        left: -75px!important;
        float: left!important;
        margin-top: 10px!important;
    }
}
@media screen and (max-width: 490px){
    table td .mobile-button1{
        margin-left: 50%!important;
        left: -78px!important;
        float: left!important;
        margin-top: 10px!important;
    }
}
@media screen and (max-width: 793px){
    .mobile-component{
        display: block!important;
    }
    .desktop-component{
        display: none!important;
    }
}
@media screen and (min-width: 793px){
    .desktop-component{
        display: block!important;
    }
    .mobile-component{
        display: none!important;
    }
}
.loading-receipt-btn{
    position: relative;
    display: inline;
    width: 15px;
    height: 15px;
    top: -3px;
}
.force-hide{
    display: none;
}
td .mobile-button-transaction{
    margin-right: 0px!important;
    left: 8px!important;
}
.desktop-component{
    display: none;
}
.mobile-component{
    display: none;
}
.mobile-div-text{
    position: relative;
    display: block;
    white-space: normal;
    text-align: left;
}
.mobile-div-text-center{
    position: relative;
    display: block;
    white-space: normal;
    text-align: center;
}
.mobile-div-text-right{
    position: relative;
    display: block;
    white-space: normal;
    text-align: right;
}
.change-credit-card{
    background-color: #aaaaaa!important;
}
.text-left{
    text-align: left!important;
}
.text-justify{
    text-align: justify;
}
.sub-link{
    color: blue!important;
}
.receipt-issued{
    font-size: 14px;
    margin-right: 29px;
}
.button-product{
    padding-top: 25px!important;
}
.header-instruction{
    font-size: 15px!important;
}
section div.table-containers{
    max-width: 83.33333%!important;
    flex: 0 0 83.33333%!important;
}
@media screen and (max-width: 991px){
    section div.table-containers{
        max-width: 100%!important;
        flex: 0 0 auto!important;
        padding-right: 14px!important;
    }
}
tr th.th-header{
    background-color: #eeeeee;
    border-bottom: 0px!important;
}
.no-top-div{
    position: relative;
    padding-top: 0px!important;
    margin-top: 0px!important;
    top: 0px!important;
}
a.link{
    color: blue;
}
.click-to-load{
    text-align: center;
}
.click-to-load span{
    position: relative;
    top: 3px;
}
.tab-content{
    padding-top: 0px!important;
}
.nav-tabs-checkout{
    border: 0px!important;
}
table th{
    border-bottom-color: #bbbbbb;
}
.table-hover{
    border: 1px solid #eeeeee;
}
.row-text-align-right{
    float: right!important;
    padding-right: 10px!important;
}
.detail-title{
    font-weight: 1000;
    font-size: 16px;
}
.row-text{
    display: inline-flex;
    position: relative;
    float: left;
    min-width: 5px!important;
    white-space: pre-wrap;
}
.section{
    padding-top: 60px!important;
    padding-bottom: 80px!important;
}
.buttons{
    position: relative!important;
    display: flex!important;
    float: right!important;
    margin-top: 0px!important;
    margin-right: 10px!important;
    font-size: 12px!important;
    height: 30px!important;
    line-height: 10px!important;
    min-width: 20px!important;
}

.form-buttons{
    padding-top: 30px;
}
.table-checkout{
    max-width: 1800px!important;
    width: auto!important;
}
.agreed-checkbox{
    padding-left: 0px!important; 
}
.disabled{
    opacity: 0.5;
    margin-bottom: -200px;
}
.table-custom th,
.table-custom td {
    padding: 15px 13px 15px 16px;
}

@media screen and (max-width: 990px) {
    .tooltip-grey-instant-title .tooltip-grey-instant-text {
        top: -70px;
        right: 0% !important;
        height: 65px !important;
    }
}

.tooltip-grey-instant-title .tooltip-grey-instant-text {
    top: -70px;
    height: 65px !important;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import Utils from '../../../js/helpers/Utils';
import Constants from '../../../js/helpers/Constants';
import ReceiptPathFactory from '../../../js/helpers/ReceiptPathFactory';
import DialogMixin from '../../../js/helpers/mixins/DialogMixin';

export default {
    props: {
        monthlyItem: {
            type: Object,
            required: true
        },
        yearlyItem: {
            type: Object,
            required: true
        },
        yearlySItem: {
            type: Object,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        },
        hasCurrentSubscription: {
            type: Boolean,
            required: true
        },
        hasPreviousShopSubscription: {
            type: Boolean,
            required: true
        }
    },
    data(){
        return {
            eowp: {
                products: {
                    monthly: {
                        item: [],
                        ref: 'EOWP_MONTHLY_ITEM'
                    },
                    yearly: {
                        item: [],
                        ref: 'EOWP_YEARLY_ITEM'
                    },
                    yearlyS: {
                        item: [],
                        ref: 'EOWP_YEARLY_S_ITEM'
                    },
                    subTypeRef: {
                        'EOWP_MONTHLY_ITEM': 'MONTHLY',
                        'EOWP_YEARLY_ITEM': 'YEARLY',
                        'EOWP_YEARLY_S_ITEM': 'YEARLY',
                    }
                },
                subscription: [],
                subscriptionType: '',
                subscriptionSource: {
                    'EXTERNAL-SUBSCRIPTION': 'ショップ外でのご注文'
                },
                externalSubscription: false,
                externalOnly: false,
                validToExpired: false,
                transactionHistoryStatus: {
                    trials: {
                        TRIAL_OLD: '30',
                        TRIAL_NEW: '14',
                        indicators: {
                            '30': ' (初月無料適用) ',
                            '14': ' (初回購入のため2週間無料適用) ',
                        },
                    },
                },
                transactionHistory: [],
                transaction: {
                    defaultItems: 3,
                    maxItems: 99999999,
                    currentItems: 3
                },
                subscriptionCycle: {
                    '1': '自動継続',
                    '3': '自動継続'
                },
                paymentStatusFlag: {
                    FAILED: 2
                },
                useStatus: {
                    '0': '停止',
                    '1': 'ご利用中',
                    '2': '停止',
                    '3': '停止',
                },
                paymentStatus: {
                    '1': 'ご請求済み',
                    '2': '課金エラー'
                },
                paymentFrequencyDescription: {
                    'MONTHLY': '月額',
                    'YEARLY': '年額'
                },
                textReference: {
                    '1': '当サービスはYYYY年MM月末日を過ぎると自動継続されます。',
                    '2': 'YYYY-MM-DD',
                    '3': '当ショップでのお支払い履歴はありません。ご購入いただいたアプリストアまたは法人申し込み窓口にてご確認ください。'
                },
                showDetail: false,
                receiptPrintTooltip: '&nbsp;発行は１回限りです。請求書も発行できます。あらかじめダウンロードの準備をお願いいたします。', //Issuance is limited to one time only. Invoices can also be issued. Please be prepared to download in advance.
                nthReceiptButtonClicked: -1,
            },
            dialogParams: {
                receiptRedirectOptions: {
                    loader: false,
                    okText: '次へ', //Next
                    cancelText: 'キャンセル', //Cancel
                    animation: 'zoom',
                    backdropClose: true,
                    html: true,
                    title: '領収書と請求書ダウンロード画面を開く', //Open Receipt and Invoice Download Screen
                    prompt: '外部リンクにリダイレクトして表示されます。<br />ダウンロード画面が表示されない場合、ブラウザのポップアップ設定をご確認ください。', //You will be redirected to an external link. If the download screen does not appear, please check your browser's pop-up settings.
                },
            },
        };
    },
    created(){
        this.eowp.products.monthly.item = this.monthlyItem;
        this.eowp.products.yearly.item = this.yearlyItem;
        this.eowp.products.yearlyS.item = this.yearlySItem;
        this.eowp.subscription = this.subscription;

        this.eowp.subscription.orderDate = Utils.formatDate(this.eowp.subscription.orderDate);
        this.eowp.subscription.orderDate = Utils.extractDateFromTimestamp(this.eowp.subscription.orderDate);
        this.eowp.subscription.validFrom = Utils.formatDate(this.eowp.subscription.validFrom);
        this.eowp.subscription.validFrom = Utils.extractDateFromTimestamp(this.eowp.subscription.validFrom);
        this.eowp.subscription.validTo = Utils.formatDate(this.eowp.subscription.validTo);
        this.eowp.subscription.validTo = Utils.extractDateFromTimestamp(this.eowp.subscription.validTo);

        let node = null;
        node = Utils.isEmpty(node) ? (this.eowp.subscription.csMatNo == this.eowp.products.monthly.item.csMatNo ? this.eowp.products.monthly.item : node) : node;
        node = Utils.isEmpty(node) ? (this.eowp.subscription.csMatNo == this.eowp.products.yearly.item.csMatNo ? this.eowp.products.yearly.item : node) : node;
        node = Utils.isEmpty(node) ? (this.eowp.subscription.csMatNo == this.eowp.products.yearlyS.item.csMatNo ? this.eowp.products.yearlyS.item : node) : node;
        this.eowp.subscriptionType = !Utils.isEmpty(node) ? this.eowp.products.subTypeRef[node.itemType] : '';

        let subSource = this.eowp.subscriptionSource[this.eowp.subscription.csOrderNo];
        if(Utils.isEmpty(subSource)){
            this.refreshTransactionHistory(this.eowp.subscription.csOrderNo);
        } else { 
            this.eowp.subscription.csOrderNo = subSource;
            this.eowp.externalSubscription = true;
        }

        if(!this.hasCurrentSubscription && !this.hasPreviousShopSubscription && this.eowp.externalSubscription){
            this.eowp.externalOnly = true;
            this.showDetail(true);
        } 
    },
    computed: {
        ...mapGetters({
            sessionDetails: 'user/session_details'
        })
    },
    methods: {
        ...mapActions({
            getItemTransactionHistory: 'ncs/getItemTransactionHistory',
            updateReceiptStatus: 'ncs/updateReceiptStatus',
            trackClickEvent: 'ga/trackClickEvent',
            trackOutboundClickEvent: 'ga/trackOutboundClickEvent',
            getReceiptSource: 'pg/getReceiptSource',
        }),
        getItemName(itemNumber){
            let itemName = '';
            itemName = Utils.isEmpty(itemName) ? (itemNumber == this.eowp.products.monthly.item.csMatNo ? this.eowp.products.monthly.item.productName : itemName) : itemName;
            itemName = Utils.isEmpty(itemName) ? (itemNumber == this.eowp.products.yearly.item.csMatNo ? this.eowp.products.yearly.item.productName : itemName) : itemName;
            return itemName;
        },
        showTransaction(index){
            return index < this.eowp.transaction.currentItems;
        },
        manageShowTransaction(newValue, eventName){
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});

            this.eowp.transaction.currentItems = newValue;
            if(newValue == this.eowp.transaction.defaultItems){
                this.eowp.showDetail = false;
            }
        },
        transformUseDescription(text, givenDate, stepBack = false){
            let modifiedText = text;
            let extractedDate = givenDate.split('-');
            let targetYear = parseInt(extractedDate[0]);
            let targetMonth = parseInt(extractedDate[1]);
            let targetDate = parseInt(extractedDate[2]);

            if(stepBack){
                targetYear = (targetMonth > 1) ? targetYear : (targetYear - 1);
                targetMonth = (targetMonth > 1) ? (targetMonth - 1) : 12;
            }
            
            modifiedText = modifiedText.replace('YYYY', targetYear);
            modifiedText = modifiedText.replace('MM', targetMonth.toString().padStart(2, '0'));
            modifiedText = modifiedText.replace('DD', targetDate.toString().padStart(2, '0'));
            return modifiedText;
        },
        notIn(needle, stack){
            return Utils.notIn(needle, stack);
        },
        showDetail(flag){
            this.eowp.showDetail = flag;
            this.trackClickEvent({event: 'expand_prevtable_display', path: this.$route.path, title: this.$route.meta.title});
        },
        async receipt(orderNo, paymentLogSeq, nthReceiptButton){
            // Skip request when there's already a request being processed
            if(this.eowp.nthReceiptButtonClicked >= 0) return;

            this.eowp.nthReceiptButtonClicked = nthReceiptButton;
            this.trackClickEvent({event: 'issue_prevtable_ryoshusho_click', path: this.$route.path, title: this.$route.meta.title});
            if(!await this.checkActiveSession()) {
                this.eowp.nthReceiptButtonClicked = -1;
                return;
            }

            let externalReceiptSource = false;
            await this.getReceiptSource({sessionId: this.sessionDetails.sessionId, csOrderNo: orderNo, paymentLogSeq: paymentLogSeq}).then(async res => {
                if(res.records && res.records.receiptUrl){
                    externalReceiptSource = true;
                    this.$dialog.confirm({
                        title: this.dialogParams.receiptRedirectOptions.title,
                        body: this.dialogParams.receiptRedirectOptions.prompt,
                    }, this.dialogParams.receiptRedirectOptions)
                    .then(async () => {
                        Utils.forceOpenNewTab(res.records.receiptUrl);

                        //Execute receipt-view-only-once trigger, then refresh the transaction list
                        let vm = this;
                        setTimeout(()=>{ vm.eowp.nthReceiptButtonClicked = -1; }, 500);
                        await this.updateReceiptStatus({orderNo: orderNo, paymentLogSeq: paymentLogSeq});
                        this.refreshTransactionHistory(this.eowp.subscription.csOrderNo);
                        return;
                    }).catch(() => { this.eowp.nthReceiptButtonClicked = -1; });
                }
            });

            if(Utils.isEmpty(orderNo) || Utils.isEmpty(paymentLogSeq) || externalReceiptSource) return;
            let receiptPath = new ReceiptPathFactory("/receipt", this.sessionDetails.userId, this.sessionDetails.sessionId, this.eowp.subscriptionType, orderNo, paymentLogSeq);
            this.$router.push(receiptPath.finalPath);
            let vm = this;
            setTimeout(()=>{ vm.eowp.nthReceiptButtonClicked = -1; }, 500);
        },
        async refreshTransactionHistory(csOrderNo){
            await this.getItemTransactionHistory({orderId: csOrderNo}).then(res => {
                if(res.records && res.records.length > 0){
                    this.eowp.transactionHistory = res.records;
                    this.eowp.transactionHistory = this.eowp.transactionHistory.map(obj => {
                        obj.paymentDate = Utils.formatDate(obj.paymentDate);
                        obj.paymentDate = Utils.extractDateFromTimestamp(obj.paymentDate);
                        return obj;
                    });
                }
            });
        },
        purchasedTrialIndicator(orderDetail){
            let expired = Utils.dateExpired(Constants.EOWP_SHOP_SUBSCRIPTION_TRIAL_14_DAYS, orderDetail.paymentDate);
            let indicator = expired ? 
                            this.eowp.transactionHistoryStatus.trials.TRIAL_NEW : 
                            this.eowp.transactionHistoryStatus.trials.TRIAL_OLD;
            return this.eowp.transactionHistoryStatus.trials.indicators[indicator];
        },
        formatPrice(price){
            return Utils.formatNumber(price);
        },
    },
    mixins: [
        DialogMixin
    ]
};
</script>
